<template>
  <van-tabbar style="background: #efefef" v-model="currentActive">
    <van-tabbar-item to="../homepage">
      <span>首页</span>
      <template #icon="props">
        <van-icon name="wap-home" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="../alarm/alarmInfo">
      <span>告警中心</span>
      <template #icon="props">
        <van-icon name="bell" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="../history/historyInfo">
      <span>数据中心</span>
      <template #icon="props">
        <van-icon name="column" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="../common/me">
      <span>我的</span>
      <template #icon="props">
        <van-icon name="manager" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
  export default {
    name: 'tabular',
    props: {
      active: Number,
    },
    data() {
      return {
        currentActive: this.active
      }
    }
  }
</script>
